let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("9202h")).then(() => parcelRequire('7zgXj'));